import { ReactNode } from 'react';
import { CartContext } from '@/hooks/useCartContext';
import { useCart } from '@/hooks/useCart';

export function CartProvider({ children }: { children: ReactNode }) {
  const cart = useCart();
  return <CartContext.Provider value={cart}>{children}</CartContext.Provider>;
}
